/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthAppAppRouteImport } from './routes/_auth/app/_app'
import { Route as AuthAppAppIndexRouteImport } from './routes/_auth/app/_app/index'
import { Route as AuthAppAppSettingsRouteImport } from './routes/_auth/app/_app/settings'
import { Route as AuthAppAppSupportTicketsIndexRouteImport } from './routes/_auth/app/_app/support-tickets/index'
import { Route as AuthAppAppSettingsIndexRouteImport } from './routes/_auth/app/_app/settings/index'
import { Route as AuthAppAppPlatformPlansIndexRouteImport } from './routes/_auth/app/_app/platform-plans/index'
import { Route as AuthAppAppOrganizationsIndexRouteImport } from './routes/_auth/app/_app/organizations/index'
import { Route as AuthAppAppPlatformPlansNewRouteImport } from './routes/_auth/app/_app/platform-plans/new'
import { Route as AuthAppAppPlatformPlansPlanIdRouteImport } from './routes/_auth/app/_app/platform-plans/$planId'
import { Route as AuthAppAppOrganizationsOrganizationIdRouteImport } from './routes/_auth/app/_app/organizations/$organizationId'
import { Route as AuthAppAppSupportTicketsTicketIdIndexRouteImport } from './routes/_auth/app/_app/support-tickets/$ticketId/index'
import { Route as AuthAppAppSettingsAdminUsersIndexRouteImport } from './routes/_auth/app/_app/settings/admin-users/index'
import { Route as AuthAppAppOrganizationsOrganizationIdIndexRouteImport } from './routes/_auth/app/_app/organizations/$organizationId/index'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAppAppRoute = AuthAppAppRouteImport.update({
  id: '/app/_app',
  path: '/app',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppAppIndexRoute = AuthAppAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppSettingsRoute = AuthAppAppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppSupportTicketsIndexRoute =
  AuthAppAppSupportTicketsIndexRouteImport.update({
    id: '/support-tickets/',
    path: '/support-tickets/',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppSettingsIndexRoute = AuthAppAppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppSettingsRoute,
} as any)
const AuthAppAppPlatformPlansIndexRoute =
  AuthAppAppPlatformPlansIndexRouteImport.update({
    id: '/platform-plans/',
    path: '/platform-plans/',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppOrganizationsIndexRoute =
  AuthAppAppOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppPlatformPlansNewRoute =
  AuthAppAppPlatformPlansNewRouteImport.update({
    id: '/platform-plans/new',
    path: '/platform-plans/new',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppPlatformPlansPlanIdRoute =
  AuthAppAppPlatformPlansPlanIdRouteImport.update({
    id: '/platform-plans/$planId',
    path: '/platform-plans/$planId',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppOrganizationsOrganizationIdRoute =
  AuthAppAppOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppSupportTicketsTicketIdIndexRoute =
  AuthAppAppSupportTicketsTicketIdIndexRouteImport.update({
    id: '/support-tickets/$ticketId/',
    path: '/support-tickets/$ticketId/',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppSettingsAdminUsersIndexRoute =
  AuthAppAppSettingsAdminUsersIndexRouteImport.update({
    id: '/admin-users/',
    path: '/admin-users/',
    getParentRoute: () => AuthAppAppSettingsRoute,
  } as any)
const AuthAppAppOrganizationsOrganizationIdIndexRoute =
  AuthAppAppOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrganizationsOrganizationIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AuthAppAppRouteWithChildren
  '/app/settings': typeof AuthAppAppSettingsRouteWithChildren
  '/app/': typeof AuthAppAppIndexRoute
  '/app/organizations/$organizationId': typeof AuthAppAppOrganizationsOrganizationIdRouteWithChildren
  '/app/platform-plans/$planId': typeof AuthAppAppPlatformPlansPlanIdRoute
  '/app/platform-plans/new': typeof AuthAppAppPlatformPlansNewRoute
  '/app/organizations': typeof AuthAppAppOrganizationsIndexRoute
  '/app/platform-plans': typeof AuthAppAppPlatformPlansIndexRoute
  '/app/settings/': typeof AuthAppAppSettingsIndexRoute
  '/app/support-tickets': typeof AuthAppAppSupportTicketsIndexRoute
  '/app/organizations/$organizationId/': typeof AuthAppAppOrganizationsOrganizationIdIndexRoute
  '/app/settings/admin-users': typeof AuthAppAppSettingsAdminUsersIndexRoute
  '/app/support-tickets/$ticketId': typeof AuthAppAppSupportTicketsTicketIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AuthAppAppIndexRoute
  '/app/platform-plans/$planId': typeof AuthAppAppPlatformPlansPlanIdRoute
  '/app/platform-plans/new': typeof AuthAppAppPlatformPlansNewRoute
  '/app/organizations': typeof AuthAppAppOrganizationsIndexRoute
  '/app/platform-plans': typeof AuthAppAppPlatformPlansIndexRoute
  '/app/settings': typeof AuthAppAppSettingsIndexRoute
  '/app/support-tickets': typeof AuthAppAppSupportTicketsIndexRoute
  '/app/organizations/$organizationId': typeof AuthAppAppOrganizationsOrganizationIdIndexRoute
  '/app/settings/admin-users': typeof AuthAppAppSettingsAdminUsersIndexRoute
  '/app/support-tickets/$ticketId': typeof AuthAppAppSupportTicketsTicketIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/app/_app': typeof AuthAppAppRouteWithChildren
  '/_auth/app/_app/settings': typeof AuthAppAppSettingsRouteWithChildren
  '/_auth/app/_app/': typeof AuthAppAppIndexRoute
  '/_auth/app/_app/organizations/$organizationId': typeof AuthAppAppOrganizationsOrganizationIdRouteWithChildren
  '/_auth/app/_app/platform-plans/$planId': typeof AuthAppAppPlatformPlansPlanIdRoute
  '/_auth/app/_app/platform-plans/new': typeof AuthAppAppPlatformPlansNewRoute
  '/_auth/app/_app/organizations/': typeof AuthAppAppOrganizationsIndexRoute
  '/_auth/app/_app/platform-plans/': typeof AuthAppAppPlatformPlansIndexRoute
  '/_auth/app/_app/settings/': typeof AuthAppAppSettingsIndexRoute
  '/_auth/app/_app/support-tickets/': typeof AuthAppAppSupportTicketsIndexRoute
  '/_auth/app/_app/organizations/$organizationId/': typeof AuthAppAppOrganizationsOrganizationIdIndexRoute
  '/_auth/app/_app/settings/admin-users/': typeof AuthAppAppSettingsAdminUsersIndexRoute
  '/_auth/app/_app/support-tickets/$ticketId/': typeof AuthAppAppSupportTicketsTicketIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/app/settings'
    | '/app/'
    | '/app/organizations/$organizationId'
    | '/app/platform-plans/$planId'
    | '/app/platform-plans/new'
    | '/app/organizations'
    | '/app/platform-plans'
    | '/app/settings/'
    | '/app/support-tickets'
    | '/app/organizations/$organizationId/'
    | '/app/settings/admin-users'
    | '/app/support-tickets/$ticketId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/app/platform-plans/$planId'
    | '/app/platform-plans/new'
    | '/app/organizations'
    | '/app/platform-plans'
    | '/app/settings'
    | '/app/support-tickets'
    | '/app/organizations/$organizationId'
    | '/app/settings/admin-users'
    | '/app/support-tickets/$ticketId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_auth/app/_app'
    | '/_auth/app/_app/settings'
    | '/_auth/app/_app/'
    | '/_auth/app/_app/organizations/$organizationId'
    | '/_auth/app/_app/platform-plans/$planId'
    | '/_auth/app/_app/platform-plans/new'
    | '/_auth/app/_app/organizations/'
    | '/_auth/app/_app/platform-plans/'
    | '/_auth/app/_app/settings/'
    | '/_auth/app/_app/support-tickets/'
    | '/_auth/app/_app/organizations/$organizationId/'
    | '/_auth/app/_app/settings/admin-users/'
    | '/_auth/app/_app/support-tickets/$ticketId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/app/_app': {
      id: '/_auth/app/_app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthAppAppRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app/': {
      id: '/_auth/app/_app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AuthAppAppIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/settings': {
      id: '/_auth/app/_app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AuthAppAppSettingsRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/support-tickets/': {
      id: '/_auth/app/_app/support-tickets/'
      path: '/support-tickets'
      fullPath: '/app/support-tickets'
      preLoaderRoute: typeof AuthAppAppSupportTicketsIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/settings/': {
      id: '/_auth/app/_app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AuthAppAppSettingsIndexRouteImport
      parentRoute: typeof AuthAppAppSettingsRoute
    }
    '/_auth/app/_app/platform-plans/': {
      id: '/_auth/app/_app/platform-plans/'
      path: '/platform-plans'
      fullPath: '/app/platform-plans'
      preLoaderRoute: typeof AuthAppAppPlatformPlansIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/organizations/': {
      id: '/_auth/app/_app/organizations/'
      path: '/organizations'
      fullPath: '/app/organizations'
      preLoaderRoute: typeof AuthAppAppOrganizationsIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/platform-plans/new': {
      id: '/_auth/app/_app/platform-plans/new'
      path: '/platform-plans/new'
      fullPath: '/app/platform-plans/new'
      preLoaderRoute: typeof AuthAppAppPlatformPlansNewRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/platform-plans/$planId': {
      id: '/_auth/app/_app/platform-plans/$planId'
      path: '/platform-plans/$planId'
      fullPath: '/app/platform-plans/$planId'
      preLoaderRoute: typeof AuthAppAppPlatformPlansPlanIdRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/organizations/$organizationId': {
      id: '/_auth/app/_app/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/app/organizations/$organizationId'
      preLoaderRoute: typeof AuthAppAppOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/support-tickets/$ticketId/': {
      id: '/_auth/app/_app/support-tickets/$ticketId/'
      path: '/support-tickets/$ticketId'
      fullPath: '/app/support-tickets/$ticketId'
      preLoaderRoute: typeof AuthAppAppSupportTicketsTicketIdIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/settings/admin-users/': {
      id: '/_auth/app/_app/settings/admin-users/'
      path: '/admin-users'
      fullPath: '/app/settings/admin-users'
      preLoaderRoute: typeof AuthAppAppSettingsAdminUsersIndexRouteImport
      parentRoute: typeof AuthAppAppSettingsRoute
    }
    '/_auth/app/_app/organizations/$organizationId/': {
      id: '/_auth/app/_app/organizations/$organizationId/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/'
      preLoaderRoute: typeof AuthAppAppOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrganizationsOrganizationIdRoute
    }
  }
}

interface AuthAppAppSettingsRouteChildren {
  AuthAppAppSettingsIndexRoute: typeof AuthAppAppSettingsIndexRoute
  AuthAppAppSettingsAdminUsersIndexRoute: typeof AuthAppAppSettingsAdminUsersIndexRoute
}

const AuthAppAppSettingsRouteChildren: AuthAppAppSettingsRouteChildren = {
  AuthAppAppSettingsIndexRoute: AuthAppAppSettingsIndexRoute,
  AuthAppAppSettingsAdminUsersIndexRoute:
    AuthAppAppSettingsAdminUsersIndexRoute,
}

const AuthAppAppSettingsRouteWithChildren =
  AuthAppAppSettingsRoute._addFileChildren(AuthAppAppSettingsRouteChildren)

interface AuthAppAppOrganizationsOrganizationIdRouteChildren {
  AuthAppAppOrganizationsOrganizationIdIndexRoute: typeof AuthAppAppOrganizationsOrganizationIdIndexRoute
}

const AuthAppAppOrganizationsOrganizationIdRouteChildren: AuthAppAppOrganizationsOrganizationIdRouteChildren =
  {
    AuthAppAppOrganizationsOrganizationIdIndexRoute:
      AuthAppAppOrganizationsOrganizationIdIndexRoute,
  }

const AuthAppAppOrganizationsOrganizationIdRouteWithChildren =
  AuthAppAppOrganizationsOrganizationIdRoute._addFileChildren(
    AuthAppAppOrganizationsOrganizationIdRouteChildren,
  )

interface AuthAppAppRouteChildren {
  AuthAppAppSettingsRoute: typeof AuthAppAppSettingsRouteWithChildren
  AuthAppAppIndexRoute: typeof AuthAppAppIndexRoute
  AuthAppAppOrganizationsOrganizationIdRoute: typeof AuthAppAppOrganizationsOrganizationIdRouteWithChildren
  AuthAppAppPlatformPlansPlanIdRoute: typeof AuthAppAppPlatformPlansPlanIdRoute
  AuthAppAppPlatformPlansNewRoute: typeof AuthAppAppPlatformPlansNewRoute
  AuthAppAppOrganizationsIndexRoute: typeof AuthAppAppOrganizationsIndexRoute
  AuthAppAppPlatformPlansIndexRoute: typeof AuthAppAppPlatformPlansIndexRoute
  AuthAppAppSupportTicketsIndexRoute: typeof AuthAppAppSupportTicketsIndexRoute
  AuthAppAppSupportTicketsTicketIdIndexRoute: typeof AuthAppAppSupportTicketsTicketIdIndexRoute
}

const AuthAppAppRouteChildren: AuthAppAppRouteChildren = {
  AuthAppAppSettingsRoute: AuthAppAppSettingsRouteWithChildren,
  AuthAppAppIndexRoute: AuthAppAppIndexRoute,
  AuthAppAppOrganizationsOrganizationIdRoute:
    AuthAppAppOrganizationsOrganizationIdRouteWithChildren,
  AuthAppAppPlatformPlansPlanIdRoute: AuthAppAppPlatformPlansPlanIdRoute,
  AuthAppAppPlatformPlansNewRoute: AuthAppAppPlatformPlansNewRoute,
  AuthAppAppOrganizationsIndexRoute: AuthAppAppOrganizationsIndexRoute,
  AuthAppAppPlatformPlansIndexRoute: AuthAppAppPlatformPlansIndexRoute,
  AuthAppAppSupportTicketsIndexRoute: AuthAppAppSupportTicketsIndexRoute,
  AuthAppAppSupportTicketsTicketIdIndexRoute:
    AuthAppAppSupportTicketsTicketIdIndexRoute,
}

const AuthAppAppRouteWithChildren = AuthAppAppRoute._addFileChildren(
  AuthAppAppRouteChildren,
)

interface AuthRouteChildren {
  AuthAppAppRoute: typeof AuthAppAppRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppAppRoute: AuthAppAppRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
